/*global FormController, WebView, moment*/
var trackedPostmailEventCreatePopupController = new FormController("iz_tracked_postmail_event", 
    {
        directory: "views/tracked",
        name: "trackedPostmailEventCreatePopup",
        route: "tracked-postmail-event-create-popup",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        popup: {
            //size can by small, medium, large and wide
            size: "medium"
        }
    }
);

//handle the opening parameters
trackedPostmailEventCreatePopupController.prepareDataOnEnter = function(data, callback){
    if(!data || typeof(data) === "object"){
        //received a full object or nothing, go ahead with it
        return callback(null, data) ;
    }
    //receive an id, read the record from database
    this.api.db.iz_tracked_postmail_event.searchFirst({id: data}, function(err, record){
        if(err){ return callback(err) ;}
        callback(null, record) ;
    }.bind(this)) ;
} ;

//the popup will never be in read mode, switch to create or modify
trackedPostmailEventCreatePopupController.onChangeMode = function(ev){
    if(ev.data === "read"){
        if(!this.data.id){
            this.setMode("create") ;
        }else{
            this.setMode("modify") ;
        }
    }
} ;

trackedPostmailEventCreatePopupController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};

//close when user click on cancel button
trackedPostmailEventCreatePopupController.onCancel = function(){
    this.view.close() ;
};

//save and close on validate
trackedPostmailEventCreatePopupController.onValidate = function(){
    this.view.longTask(function(done){
        this.doValidate(function(err, savedRecord){
            if(err){ return done(err); }
            if(!savedRecord){
                //check failed
                return done() ;
            }
            done() ;

            WebView.longTask(function(done){
                if(this.view.EL.customFile && this.view.EL.customFile.files.length>0){
                    var file = this.view.EL.customFile.files[0] ;
                    var binaryRecord = {
                        res_model: "iz.tracked.postmail.event", 
                        mimetype: file.type,
                        datas_fname : file.name,
                        name: "proof",
                        res_id: savedRecord.id
                    };
    
                    this.api.api.saveBinary(file, binaryRecord, function(err){
                        if(err){ return done(err) ;}
                        done() ;
                    }.bind(this)) ;
                }else{
                    done() ;
                }
            }.bind(this), function(err){
                if(!err){
                    this.mode = 'read' ; //avoid abort input warning
                    this.view.close() ;
                }
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

module.exports = trackedPostmailEventCreatePopupController ;